import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { EntitiesFacade } from 'src/app/abstraction/entities.facade';
import { CasesFacade } from 'src/app/abstraction/cases.facade';
import { OperatorsQPS, OperatorsService } from 'src/app/core/services/operators.service';
import { CustomValidators } from 'src/app/core/validators/custom-validators';
import { Case } from 'src/app/shared/models/case';
import { Operator } from 'src/app/shared/models/operator';
import Swal from 'sweetalert2';
import { AppThemeService } from 'src/app/core/theme/app-theme.service';
import { map } from 'rxjs/operators';
import { ExperienceI18nService } from 'src/app/core/experience/experience-i18n.service';

@Component({
  selector: 'app-operators-selector',
  templateUrl: './operators-selector.component.html',
  styleUrls: ['./operators-selector.component.scss']
})
export class OperatorsSelectorComponent implements OnInit {

  public readonly OPERATORS = "operators";
  public readonly OPERATORS_SEARCHING = 'operatorsSearching';

  operatorSelectorForm: FormGroup;

  @Input() case: Case;

  operators: Operator[];

  operatorsOnSelect: Operator[];
  actualOperator: Operator;


  constructor(
    private formBuilder: FormBuilder,
    private entitiesFacade: EntitiesFacade,
    private casesFacade: CasesFacade,
    private operatorsService: OperatorsService,
    private appTheme: AppThemeService,
    private experienceI18n: ExperienceI18nService,
  ) { }

  ngOnInit(): void {
    console.log(this.case);
    this.operatorSelectorForm = this.createCorporateProvidersForm();
    let providerQPS: OperatorsQPS = {
      active: true
    }
    this.entitiesFacade.loadOperators(providerQPS).subscribe();
    this.entitiesFacade.getOperators$().subscribe((operators: Operator[]) => {
      this.operators = operators;
    });
    if (this.case.operator) {
      this.setActualOperator(this.case.operator);
    } else if (this.case.operatorId) {
      this.operatorsService
        .getOperators({ id: this.case.operatorId })
        .pipe(map(response => response.data?.[0]))
        .subscribe(operator => {
          if (operator) {
            this.setActualOperator(operator);
          }
        });
    }
  }

  private setActualOperator(operator: Operator): void {
    this.actualOperator = operator;
    this.operatorsOnSelect = [operator];
    this.operatorSelectorForm?.get(this.OPERATORS)?.setValue(operator.id?.toString(), { emitEvent: false });
  }

  calculateName(element: Operator) {
    if (!element) {
        return null;
    }
    const fullName = [element.surname, element.name].filter(Boolean).join(' ').trim();
    return fullName || null;
    }

  calculateId(element: Operator) {
    return element ? element.id : null;
  }

  createCorporateProvidersForm(): FormGroup {
    return this.formBuilder.group({
      [this.OPERATORS]: ['', [CustomValidators.required(this.experienceI18n.translate('modules.cases.operators-selector.validators.state-required', undefined, 'Estado requerido'))]],
      [this.OPERATORS_SEARCHING]: [''],
    });
  }

  onUpdateOperator(selectedOperator: Operator) {
    const operatorId = selectedOperator?.id;

    if (!operatorId) {
        return;
    }

    const swalWithCustomizeButtons = Swal.mixin({
        customClass: {
        confirmButton: 'btnSwalConfirm',
        cancelButton: 'btnSwalCancel'
        },
        buttonsStyling: true
    });

    swalWithCustomizeButtons.fire({
        text: this.experienceI18n.translate('modules.cases.operators-selector.confirma-el-cambio-de-operador', undefined, 'Confirma el cambio de operador'),
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: this.appTheme.getToken('statusNotDone'),
        confirmButtonText: this.experienceI18n.translate('common.confirm', undefined, 'Confirmar'),
        cancelButtonText: this.experienceI18n.translate('common.cancel', undefined, 'Cancelar'),
        showLoaderOnConfirm: true,
        reverseButtons: true,
        preConfirm: () => {
        const body = { operatorId };

        return this.casesFacade.updateCase(body, this.case.id).toPromise().then((updatedCase) => {
            const operator = updatedCase?.operator ?? selectedOperator;

            this.setActualOperator(operator);

            this.casesFacade.updateCase$({
            operatorId,
            operator
            }, this.case.id);

            return swalWithCustomizeButtons.fire({
            text: this.experienceI18n.translate('modules.cases.operators-selector.caso-delegado-correctamente', undefined, 'Caso delegado correctamente'),
            icon: 'success'
            });
        });
      },
      allowOutsideClick: () => !Swal.isLoading()
    })
  }

  getOperatorsByNameAndSurname = (value: string) => this.operatorsService.getOperators({ fullName_like: value, active: true }).pipe(map(body => body.data));
}
